import {Component, inject, Input, OnInit} from '@angular/core';
import {MenuItem} from '../../../../interfaces/data.interfaces';
import {StorageService} from '../../../../../services/storage-service.service';
import {NgxPermissionsService} from 'ngx-permissions';
import {NavigationEnd, Router} from '@angular/router';
import {MenuService} from '../../../../../services/menu.service';
import {filter} from 'rxjs';
import {AuthService} from '../../../../../services/auth.service';

@Component({
    selector: 'app-staff-sidebar',
    templateUrl: './staff-sidebar.component.html',
    styleUrls: ['./staff-sidebar.component.scss'],
    standalone: false
})
export class StaffSidebarComponent implements OnInit {
  activeModuleName :string;
  currentUser :string;
  shopName :string;
  activeModule :MenuItem;


  permissionService = inject(NgxPermissionsService);
  storageService = inject(StorageService);
  router = inject(Router);
  menuService = inject(MenuService);
  authService = inject(AuthService);

  mainMenu: MenuItem[];
  @Input() sidebarMenu: MenuItem[];
  @Input() moduleTitle: string;
  @Input() moduleIconType: string;
  @Input() moduleIconTitle: string;

  menuData: MenuItem[];

  userPermissions = this.permissionService.getPermissions();

  ngOnInit(): void {
    this.mainMenu = this.menuService.mainMenu;
    this.menuData = this.sidebarMenu;

    this.currentUser = this.storageService.get('username');
    this.shopName = this.storageService.get('shop');

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.setActiveModuleName();
    });
    this.setActiveModuleName();
    this.redirectToFirstAccessibleModule();

  }

  /**
   * Landing on the bare hub route (no module picked yet) shouldn't force the
   * user to click a tile — send them straight to the first module their
   * permissions actually grant.
   */
  private redirectToFirstAccessibleModule(): void {
    if (this.router.url.split('?')[0] !== '/dashboard') {
      return;
    }

    const grantedPermissions = Object.keys(this.permissionService.getPermissions());
    const firstAccessible = this.mainMenu.find(item =>
      !item.permissions?.length || this.has(grantedPermissions, item.permissions)
    );

    if (firstAccessible?.route) {
      this.router.navigateByUrl(firstAccessible.route);
    }
  }

  setActiveModuleName(): void {
    const currentUrl = this.router.url;
    const activeModule = this.mainMenu.find(item => {
      return currentUrl.startsWith(item.route);
    });

    this.activeModule = activeModule;
    // Update the display variable
    this.activeModuleName = activeModule ? activeModule.name : '';

  }

  isActiveRoute(children: MenuItem[]) {
    return children?.findIndex( d => d?.route === this.router?.url) > -1;
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  getChildrenPermission(children: MenuItem[]): boolean {
    const permissionsExist: any = [];
    children?.forEach( c => permissionsExist.push(...c?.permissions));
    return this.has(Object.keys(this.userPermissions), permissionsExist);
  }

  protected has(arr: string[], valuesToCheck: string[]): boolean {
    for (const value of valuesToCheck) {
      if (arr.includes(value)) {
        return true;
      }
    }
    return false;
  }

}
